import { render, staticRenderFns } from "./RecipeHeader.vue?vue&type=template&id=b041144a&scoped=true&"
import script from "./RecipeHeader.vue?vue&type=script&lang=js&"
export * from "./RecipeHeader.vue?vue&type=script&lang=js&"
import style0 from "./RecipeHeader.vue?vue&type=style&index=0&id=b041144a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b041144a",
  null
  
)

export default component.exports